import {
  GET_POST,
  SET_PAGE,
  SET_SEARCH,
  SET_PRODUCT_ID,
  SET_ORDER_BY,
  SET_SORT_BY,
} from "../../shared/constants/ActionTypes";

const initialPost = {
  post: [],
  postCount: 0,
  page: 1,
  search: "",
  courseId: "",
};

const postReducer = (state = initialPost, action) => {
  switch (action.type) {
    case GET_POST:
      return {
        ...state,
        post: action.payload?.posts.map((item) => {
          return {
            ...item,
            studentName:
              item?.studentId?.firstName + " " + item?.studentId?.lastName,
            studentEmail: item?.studentId?.email,
          };
        }),
        postCount: action.payload?.total,
      };
    case SET_PAGE:
      return {
        ...state,
        page: action.payload,
      };

    case SET_SEARCH:
      return {
        ...state,
        search: action.payload,
      };
    case SET_PRODUCT_ID:
      return {
        ...state,
        courseId: action.payload,
      };

    default:
      return state;
  }
};

export default postReducer;
